import BaseNumberVTextField from './BaseNumberVTextField'

function parseISOString(s) {
  const b = s.split(/\D+/)
  return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]))
}

// Vuetify 3 migration: inherits the <v-text-field> wrapper machinery from
// BaseNumberVTextField (raw model, formatted-on-blur display, focus/blur exposure).
// parseNumeric:false because a date value is formatted as-is, not parsed as a number.
export default {
  extends: BaseNumberVTextField,
  props: {
    parseNumeric: {
      type: Boolean,
      default: false,
    },
    blurredFormat: {
      type: Function,
      default: (v) => {
        if (v)
          return (
            parseISOString(v).toISOString().substring(0, 10) +
            '  -  ' +
            parseISOString(v).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })
          )
      },
    },
  },
}
